import { isArray } from 'lodash';
import { AvailabilityType, JsonData, ServiceType } from 'types';

const canBeRemoteService = (serviceType: ServiceType | ServiceType[]): boolean => {
  return (
    (isArray(serviceType) &&
      (serviceType.includes(ServiceType.Remote) || serviceType.includes(ServiceType.GeekCover))) ||
    serviceType === ServiceType.Remote ||
    serviceType === ServiceType.GeekCover
  );
};

export const getServiceFormat = (selectedProducts: JsonData, availableProducts: JsonData | null): AvailabilityType => {
  if (!selectedProducts || !availableProducts) {
    return AvailabilityType.OnSite; // Onsite by default if data is null or undefined
  }

  const anyProductNotAvailableForRemote = selectedProducts.some((selected) => {
    const product = availableProducts.find((p) => p.ID === parseInt(selected.id, 10));
    return product ? !canBeRemoteService(product.service_type) : false;
  });

  return anyProductNotAvailableForRemote ? AvailabilityType.OnSite : AvailabilityType.Remote;
};
